import { render, staticRenderFns } from "./BillAccount.vue?vue&type=template&id=66a4b606&scoped=true"
import script from "./BillAccount.vue?vue&type=script&lang=js"
export * from "./BillAccount.vue?vue&type=script&lang=js"
import style0 from "./BillAccount.vue?vue&type=style&index=0&id=66a4b606&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a4b606",
  null
  
)

export default component.exports